import React from "react";
import {
  Page,
  Navbar,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  Input,
  ListItem,
  ListItemCell,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Icon,
  Button,
  Row,
  Col,
  Popup,
  Preloader,
  TextEditor,
} from "framework7-react";

import {
  PrimaryLogo,
  MerchantSvg,
  BikeSvg,
  WalletSvg,
} from "../components/crumbs";
import Cleave from "cleave.js/react";
import { PaystackButton } from "react-paystack";
import moment from "moment";
import { CSVLink } from "react-csv";
// check if staging or prod
import { PAYSTACK_PUBLIC_KEY } from "../config/envConfig";

// Redux
import { compose } from "redux";
import { connect } from "react-redux";
import { withFirestore, firestoreConnect } from "../HOCs";
import {
  toast,
  generateId,
  handleErrors,
  totalWalletBalance,
  totalAmountReceivedThroughPurchaseFromCard,
  totalAmountReceivedThroughPurchaseFromWallet,
  totalRefunds,
  totalEasychawDeposit,
  totalFailedTransactionsLength,
  totalSuccessFulTransactionsLength,
  totalTransactionsLength,
  totalPaystackFeesOnWithdrawals,
  totalPaystackFeesOnDeposits,
  totalPaystackFeesOnPurchases,
  totalWithdrawal,
  totalBonusesRewardedByEasychaw,
  totalOutbound,
  totalDeposits,
  fundWallet,
  fundAllWallets,
  paystackTransactionCharge,
  sendEasychawOneTimePassword,
  verifyEasychawOneTimePassword,
} from "../utils/_helpers";
import {
  Collections,
  FilterByText,
  FilterByNumber,
  FilterBySelect,
} from "../utils/_classes";

class AdminWallets extends React.Component {
  constructor() {
    super();

    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
        data: {},
      },

      // time range
      timeFrom: 0,
      timeTo: Date.now(),

      reference: generateId(15),
      adminFundWalletAmount: "",

      fundWalletAmount: 0,
      fundAllwalletsAmount: 0,

      unCompleteOrders: [],
      unSubscribeCompleteOrders: null,

      // state for form fields reset
      walletId: "",
      accountName: "",
      accountType: "All",
      totalNumberOfTransactions: "",
      transactionWalletId: "",
      transactionId: "",
      transactionAmount: "",
      transactionType: "All",
      transactionStatus: "All",
      intiatedBy: "All",

      // Data state
      wallets: [],
      transactions: [],

      filterBy: {
        dbName: "",
        property: "",
        value: "",
        type: "",
      },

      // trial exportcsv
      exportCSV: localStorage.exportCSV || 0,
    };
  }

  render() {
    return (
      <Page>
        <Block>
          <Row>
            <Col
              width="100"
              medium="40"
              className="heightMeasure-1"
              style={{ marginTop: "9px" }}
            >
              {/* Brand Wallet Card */}
              <div
                style={{
                  width: "103%",
                  marginLeft: "-6px",
                  position: "relative",
                }}
              >
                <WalletSvg id="admincard" title="Admin Wallet" />
                {this.props.ordered.transactions ? (
                  <span className="walletBalance">
                    {new Intl.NumberFormat("en-GB", {
                      style: "currency",
                      currency: "NGN",
                    }).format(
                      totalWalletBalance(
                        this.props.ordered.transactions,
                        this.state.unCompleteOrders,
                      ),
                    )}
                  </span>
                ) : (
                  <span className="walletBalance">NGN 0.00</span>
                )}
                <em className="walletBalanceSubText">Wallet Balance</em>
              </div>

              {/* [Card-1] Wallet History */}
              <Card style={{ margin: "10pt auto 0 auto" }}>
                <CardHeader className="no-border">Wallets History</CardHeader>
                <CardContent>
                  {!this.props.ordered.transactions ? (
                    <Block className="text-align-center">
                      <Preloader></Preloader>
                    </Block>
                  ) : (
                    <List noHairlinesMd>
                      <ListItem title="Total transactions">
                        <small slot="after">
                          {totalTransactionsLength(
                            this.props.ordered.transactions,
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem
                        style={{ color: "green" }}
                        title="Total successful transactions"
                      >
                        <small slot="after">
                          {totalSuccessFulTransactionsLength(
                            this.props.ordered.transactions,
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem
                        style={{ color: "red" }}
                        title="Total failed transactions"
                      >
                        <small slot="after">
                          {totalFailedTransactionsLength(
                            this.props.ordered.transactions,
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title="Total Purchases (card)"
                      >
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalAmountReceivedThroughPurchaseFromCard(
                              this.props.ordered.transactions,
                            ),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title="Total Purchases (wallet)"
                      >
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalAmountReceivedThroughPurchaseFromWallet(
                              this.props.ordered.transactions,
                            ),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem title="Total Easychaw deposit">
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalEasychawDeposit(
                              this.props.ordered.transactions,
                            ),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem title="Total Easychaw bonuses rewarded">
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalBonusesRewardedByEasychaw(
                              this.props.ordered.transactions,
                            ),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem title="Users deposit">
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalDeposits(this.props.ordered.transactions) -
                              totalPaystackFeesOnDeposits(
                                this.props.ordered.transactions,
                              ),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem title="Total refunds">
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalRefunds(this.props.ordered.transactions),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem title="Total outbound">
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalOutbound(this.props.ordered.transactions) -
                              totalRefunds(this.props.ordered.transactions),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem title="Total withdrawn">
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalWithdrawal(this.props.ordered.transactions),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem title="Total paystack fees">
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalPaystackFeesOnPurchases(
                              this.props.ordered.transactions,
                            ) +
                              totalPaystackFeesOnDeposits(
                                this.props.ordered.transactions,
                              ) +
                              totalPaystackFeesOnWithdrawals(
                                this.props.ordered.transactions,
                              ),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>

                      <ListItem title="Wallet balance">
                        <small slot="after">
                          {new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(
                            totalWalletBalance(
                              this.props.ordered.transactions,
                              this.state.unCompleteOrders,
                            ),
                          )}
                        </small>
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                    </List>
                  )}
                </CardContent>
              </Card>
            </Col>

            <Col width="100" medium="60">
              {/* [Card-2]  Wallets Details*/}
              <Card
                className="data-table data-table-init heightRecieve-1"
                style={{
                  width: "100%",
                  marginLeft: "0px",
                }}
              >
                <CardHeader>
                  <div className="data-table-title">Wallets</div>
                  <Button
                    outline
                    iconF7="creditcard"
                    onClick={() => {
                      this.setState({
                        ...this.state,
                        popupOpened: true,
                        popupDataChanged: true,
                        popupData: {
                          title: "Fund Wallets",
                          which: "fund-wallet",
                          data: this.state.wallets,
                        },
                      });
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;Fund Wallets
                  </Button>
                </CardHeader>
                <CardContent
                  padding={false}
                  style={{
                    width: "100%",
                    maxHeight: "calc(100% - 70px)",
                    overflow: "scroll",
                  }}
                >
                  {/* Retrieve data from wallets database */}
                  {!this.props.ordered.wallets || !this.props.data.wallets ? (
                    <Block className="text-align-center">
                      <Preloader></Preloader>
                    </Block>
                  ) : (
                    <table className="sticky">
                      <thead>
                        <tr>
                          <th>
                            <span className="table-head-label">SNo.</span>
                          </th>
                          <th>
                            <span className="table-head-label">Wallet ID</span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.walletId}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: e.target.value,
                                    accountName: "",
                                    accountNumber: "",
                                    totalNumberOfTransactions: "",
                                    transactionWalletId: "",
                                    transactionId: "",
                                    transactionAmount: "",
                                    transactionType: "All",
                                    transactionStatus: "All",
                                    intiatedBy: "All",
                                    filterBy: {
                                      dbName: "wallets",
                                      property: "id",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Account Name
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.accountName}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: "",
                                    accountName: e.target.value,
                                    accountNumber: "",
                                    totalNumberOfTransactions: "",
                                    transactionWalletId: "",
                                    transactionId: "",
                                    transactionAmount: "",
                                    transactionType: "All",
                                    transactionStatus: "All",
                                    intiatedBy: "All",
                                    filterBy: {
                                      dbName: "wallets",
                                      property: "name",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>

                          <th>
                            <span className="table-head-label">
                              Total Transactions
                            </span>
                            <div className="input">
                              <input
                                type="number"
                                value={this.state.totalNumberOfTransactions}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: "",
                                    accountName: "",
                                    accountNumber: "",
                                    totalNumberOfTransactions: e.target.value,
                                    transactionWalletId: "",
                                    transactionId: "",
                                    transactionAmount: "",
                                    transactionType: "All",
                                    transactionStatus: "All",
                                    intiatedBy: "All",
                                    filterBy: {
                                      dbName: "wallets",
                                      property: "totalNumberOfTransactions",
                                      value: e.target.value,
                                      type: "number",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">Type</span>
                            <div className="input input-dropdown">
                              <select
                                value={this.state.accountType}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: "",
                                    accountName: "",
                                    accountType: e.target.value,
                                    totalNumberOfTransactions: "",
                                    transactionWalletId: "",
                                    transactionId: "",
                                    transactionAmount: "",
                                    transactionType: "All",
                                    transactionStatus: "All",
                                    intiatedBy: "All",
                                    filterBy: {
                                      dbName: "wallets",
                                      property: "type",
                                      value: e.target.value,
                                      type: "select",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              >
                                <option value="All">All</option>
                                <option value="bonuses">Users</option>
                                <option value="business">Partner</option>
                              </select>
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Wallet Balance
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Withdrawal Access
                            </span>
                          </th>

                          <th>
                            <span className="table-head-label">
                              Wallet Details
                            </span>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {this.state.wallets.map(
                          (
                            {
                              id,
                              bankDetails,
                              ban,
                              walletBalance,
                              cash,
                              bonuses,
                              name,
                            },
                            i,
                          ) => (
                            <tr key={id}>
                              <td>{i + 1}</td>
                              <td>{id}</td>
                              <td>
                                <div>
                                  {this.props.data.wallets[id].name
                                    ? this.props.data.wallets[id].name
                                    : "-"}
                                </div>
                              </td>

                              <td>
                                {this.props.ordered.transactions &&
                                  this.props.ordered.transactions.filter(
                                    ({ walletId }) => walletId === id,
                                  ).length}
                              </td>
                              <td>
                                {+this.props.data.wallets[id].bonuses >= 0
                                  ? "User"
                                  : "Partner"}
                              </td>
                              <td>
                                <div>
                                  {new Intl.NumberFormat("en-GB", {
                                    style: "currency",
                                    currency: "NGN",
                                  }).format(
                                    +this.props.data.wallets[id].bonuses >= 0
                                      ? this.props.data.wallets[id].cash
                                      : this.props.data.wallets[id]
                                          .walletBalance,
                                  )}
                                </div>
                              </td>
                              <td>
                                {this.props.data.wallets[id].ban ? (
                                  <div>Access Denied</div>
                                ) : (
                                  <div>Access</div>
                                )}
                              </td>

                              <td>
                                <Button
                                  fill
                                  onClick={() => {
                                    this.setState({
                                      ...this.state,
                                      popupOpened: true,
                                      popupDataChanged: true,
                                      popupData: {
                                        title: "Wallet Details",
                                        which: "view-wallet",
                                        data: {
                                          id,
                                          bankDetails,
                                          ban,
                                          walletBalance,
                                          cash,
                                          bonuses,
                                          name,
                                        },
                                      },
                                    });
                                  }}
                                >
                                  Details
                                </Button>
                              </td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  )}
                </CardContent>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              {/* [Card-3] Transactions Table */}
              <Card
                className="data-table data-table-init"
                style={{
                  width: "100%",
                  marginLeft: "0px",
                  marginBottom: "80px",
                  // maxHeight: '700px',
                }}
              >
                <CardHeader>
                  <div className="data-table-title">Transactions</div>

                  {!this.props.ordered.transactions ? (
                    <Block className="text-align-center">
                      <Preloader></Preloader>
                    </Block>
                  ) : this.state.transactions.length > 0 ? (
                    this.state.exportCSV <= 2 ? (
                      <CSVLink
                        data={this.state.transactions}
                        filename="Transactions"
                        className="button button-outline external"
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            exportCSV: this.state.exportCSV + 1,
                          });
                          localStorage.exportCSV
                            ? ++localStorage.exportCSV
                            : (localStorage.exportCSV = 0);
                        }}
                      >
                        <img
                          src="static/excel.svg"
                          width="18"
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                          }}
                        />
                        &nbsp;&nbsp; Export CSV
                      </CSVLink>
                    ) : (
                      <Button
                        outline
                        onClick={() => {
                          toast(this.$f7.toast, {
                            text: "Trial expired... Feature update",
                            position: "center",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        }}
                      >
                        <img
                          src="static/excel.svg"
                          width="18"
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                          }}
                        />
                        &nbsp;&nbsp; Export CSV
                      </Button>
                    )
                  ) : (
                    <Button outline>0 Export Data</Button>
                  )}
                </CardHeader>
                <CardContent
                  padding={false}
                  style={{
                    width: "100%",
                    // maxHeight: '600px',
                    maxHeight:
                      parseInt(window.innerWidth) <= 1400 ? "70vh" : "80vh",
                    paddingBottom: "20px",
                    overflow: "scroll",
                  }}
                >
                  {!this.props.ordered.transactions ? (
                    <Block className="text-align-center">
                      <Preloader></Preloader>
                    </Block>
                  ) : (
                    <table className="sticky">
                      <thead>
                        <tr>
                          <th>
                            <span className="table-head-label">SNo.</span>
                          </th>
                          <th>
                            <span className="table-head-label">Wallet ID</span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.transactionWalletId}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: "",
                                    accountName: "",
                                    accountNumber: "",
                                    totalNumberOfTransactions: "",
                                    transactionWalletId: e.target.value,
                                    transactionId: "",
                                    transactionAmount: "",
                                    transactionType: "All",
                                    transactionStatus: "All",
                                    intiatedBy: "All",
                                    filterBy: {
                                      dbName: "transactions",
                                      property: "walletId",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Transaction ID
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.transactionId}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: "",
                                    accountName: "",
                                    accountNumber: "",
                                    totalNumberOfTransactions: "",
                                    transactionWalletId: "",
                                    transactionId: e.target.value,
                                    transactionAmount: "",
                                    transactionType: "All",
                                    transactionStatus: "All",
                                    intiatedBy: "All",
                                    filterBy: {
                                      dbName: "transactions",
                                      property: "id",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Transaction Amount
                            </span>
                            <div className="input">
                              <input
                                type="number"
                                value={this.state.transactionAmount}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: "",
                                    accountName: "",
                                    accountNumber: "",
                                    totalNumberOfTransactions: "",
                                    transactionWalletId: "",
                                    transactionId: "",
                                    transactionAmount: e.target.value,
                                    transactionType: "All",
                                    transactionStatus: "All",
                                    intiatedBy: "All",
                                    filterBy: {
                                      dbName: "transactions",
                                      property: "amount",
                                      value: e.target.value,
                                      type: "number",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Service Charges
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Wallet Amount
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">Type</span>
                            <div className="input input-dropdown">
                              <select
                                value={this.state.transactionType}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: "",
                                    accountName: "",
                                    accountNumber: "",
                                    totalNumberOfTransactions: "",
                                    transactionWalletId: "",
                                    transactionId: "",
                                    transactionAmount: "",
                                    transactionType: e.target.value,
                                    transactionStatus: "All",
                                    intiatedBy: "All",
                                    filterBy: {
                                      dbName: "transactions",
                                      property: "type",
                                      value: e.target.value,
                                      type: "select",
                                    },
                                  })
                                }
                              >
                                <option value="All">All</option>
                                <option value="Received">Received</option>
                                <option value="Withdrawn">Withdrawn</option>
                                <option value="Deposit">Deposit</option>
                                <option value="Outbound">Outbound</option>
                              </select>
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Initiated By
                            </span>

                            <div className="input input-dropdown">
                              <select
                                value={this.state.transactionStatus}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: "",
                                    accountName: "",
                                    accountNumber: "",
                                    totalNumberOfTransactions: "",
                                    transactionWalletId: "",
                                    transactionId: "",
                                    transactionAmount: "",
                                    transactionType: "All",
                                    transactionStatus: e.target.value,
                                    intiatedBy: e.target.value,
                                    filterBy: {
                                      dbName: "transactions",
                                      property: "by",
                                      value: e.target.value,
                                      type: "select",
                                    },
                                  })
                                }
                              >
                                <option value="All">All</option>
                                <option value="Delivery">Delivery Agent</option>
                                <option value="Merchant">Vendor</option>
                                <option value="Easychaw">Easychaw</option>
                                <option value="User">Easychaw User</option>
                                <option value="Direct">Direct</option>
                              </select>
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">Status</span>
                            <div className="input input-dropdown">
                              <select
                                value={this.state.transactionStatus}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    walletId: "",
                                    accountName: "",
                                    accountNumber: "",
                                    totalNumberOfTransactions: "",
                                    transactionWalletId: "",
                                    transactionId: "",
                                    transactionAmount: "",
                                    transactionType: "All",
                                    transactionStatus: e.target.value,
                                    intiatedBy: "All",
                                    filterBy: {
                                      dbName: "transactions",
                                      property: "status",
                                      value: e.target.value,
                                      type: "select",
                                    },
                                  })
                                }
                              >
                                <option value="All">All</option>
                                <option value="Success">Success</option>
                                <option value="Failed">Failed</option>
                              </select>
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">Timestamp</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Description
                            </span>
                          </th>
                        </tr>
                      </thead>
                      {this.state.transactions.length === 0 ? (
                        <tbody>
                          <tr className="block-info">
                            <td colSpan={11}>
                              No transactions available at the moment
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {this.state.transactions
                            .sort(
                              (a, b) =>
                                +moment(b.timestamp) - +moment(a.timestamp),
                            )
                            .map((transaction, i) => (
                              <tr key={transaction.id}>
                                <td>{i + 1}</td>

                                {/* Wallet Id */}
                                <td>
                                  <div>{transaction.walletId}</div>
                                </td>

                                {/* Transaction Id */}
                                <td>
                                  <div>{transaction.id}</div>
                                </td>

                                {/* Transaction Amount */}
                                <td>
                                  <div>
                                    {new Intl.NumberFormat("en-GB", {
                                      style: "currency",
                                      currency: "NGN",
                                    }).format(+transaction.amount)}
                                  </div>
                                </td>

                                {/* Fee Charges */}
                                <td
                                  style={{
                                    color:
                                      transaction.type == "Received" &&
                                      transaction.by === "Easychaw"
                                        ? "green"
                                        : transaction.by ||
                                          transaction.type === "Deposit"
                                        ? "orange"
                                        : "red",
                                  }}
                                >
                                  <div>
                                    {transaction.type === "Deposit" ||
                                    transaction.type === "Withdrawn"
                                      ? new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(+transaction.fee || 0)
                                      : transaction.type == "Received" &&
                                        transaction.by !== "Easychaw"
                                      ? new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(0)
                                      : new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(
                                          +transaction.paystackCharge || 0,
                                        )}
                                  </div>
                                </td>

                                {/* Wallet Amount */}
                                <td
                                  style={{
                                    color:
                                      transaction.type == "Received" &&
                                      transaction.by === "Easychaw"
                                        ? "green"
                                        : (transaction.type == "Received" &&
                                            transaction.by !== "Easychaw") ||
                                          transaction.type === "Deposit"
                                        ? "orange"
                                        : "red",
                                  }}
                                >
                                  <div>
                                    {transaction.type === "Deposit" ||
                                    transaction.type === "Withdrawn"
                                      ? new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(
                                          +transaction.amount -
                                            (+transaction.fee || 0),
                                        )
                                      : transaction.type == "Received" &&
                                        transaction.by !== "Easychaw"
                                      ? new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(+transaction.amount)
                                      : new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(
                                          +transaction.amount -
                                            (+transaction.paystackCharge || 0),
                                        )}
                                  </div>
                                </td>

                                {/* Transaction Type */}
                                <td>
                                  <div>
                                    {transaction.type === "Received" &&
                                    transaction.by !== "Easychaw"
                                      ? "Outbound"
                                      : transaction.type}
                                  </div>
                                </td>

                                <td>
                                  <div>
                                    {transaction.type == "Withdrawn"
                                      ? "Direct"
                                      : transaction.by}
                                  </div>
                                </td>
                                <td
                                  style={{
                                    color:
                                      transaction.status === "Success"
                                        ? "green"
                                        : "red",
                                  }}
                                >
                                  <div>{transaction.status}</div>
                                </td>
                                <td>
                                  <div>
                                    {moment(transaction.timestamp).fromNow()}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {transaction.status === "Success"
                                      ? transaction.type === "Withdrawn"
                                        ? `Cash Withdrawn by ${transaction.name}.`
                                        : transaction.type === "Deposit"
                                        ? `Cash Deposited by ${transaction.name}`
                                        : transaction.type === "Received" &&
                                          transaction.by === "Easychaw"
                                        ? transaction.note
                                          ? `${transaction.note} made by ${
                                              transaction.name
                                                ? " " + transaction.name
                                                : "."
                                            }`
                                          : `Purchase made${
                                              transaction.name
                                                ? " " + transaction.name
                                                : "."
                                            }`
                                        : transaction.type === "Received" &&
                                          transaction.by === "Merchant"
                                        ? `Cash Received by merchant${
                                            transaction.orderId
                                              ? " " +
                                                (transaction.name ||
                                                  "(Name unavailable. Please use the wallet ID to identify merchant)") +
                                                " for order: " +
                                                transaction.orderId
                                              : "."
                                          }`
                                        : transaction.type === "Received" &&
                                          transaction.by === "User"
                                        ? `${
                                            transaction.reason
                                          } received by user${
                                            transaction.orderId
                                              ? " " +
                                                (transaction.name ||
                                                  "(Name unavailable. Please use the wallet ID to identify user)") +
                                                " for order: " +
                                                transaction.orderId
                                              : "."
                                          }`
                                        : transaction.type === "Received" &&
                                          transaction.by === "Referral Agent"
                                        ? `Commission Received by referral agent${
                                            transaction.orderId
                                              ? " " +
                                                (transaction.referralAgentName ||
                                                  "(Name unavailable. Please use the wallet ID to identify agent)") +
                                                " for order: " +
                                                transaction.orderId
                                              : "."
                                          }`
                                        : `Cash Received by delivery agent${
                                            transaction.orderId
                                              ? " " +
                                                (transaction.name ||
                                                  "(Name unavailable. Please use the wallet ID to identify delivery agent)") +
                                                " for order: " +
                                                transaction.orderId
                                              : "."
                                          }`
                                      : transaction.type === "Received" &&
                                        transaction.by === "Merchant"
                                      ? `Cash lost due to declined order by merchant${
                                          transaction.orderId
                                            ? " " +
                                              transaction.name +
                                              " for order: " +
                                              transaction.orderId
                                            : "."
                                        }`
                                      : transaction.type === "Received" &&
                                        transaction.by === "Referral Agent"
                                      ? `Commission lost due to order declined by referral agent${
                                          transaction.orderId
                                            ? " " +
                                              (transaction.referralAgentName ||
                                                "(Name unavailable. Please use the wallet ID to identify agent)") +
                                              " for order: " +
                                              transaction.orderId
                                            : "."
                                        }`
                                      : `Cash lost due to order declined by delivery agent${
                                          transaction.orderId
                                            ? " " +
                                              (transaction.name ||
                                                "(Name unavailable. Please use the wallet ID to identify delivery agent)") +
                                              " for order: " +
                                              transaction.orderId
                                            : "."
                                        }`}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      )}
                    </table>
                  )}
                </CardContent>
              </Card>
            </Col>
          </Row>
        </Block>

        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() => {
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "", data: {} },
              vendor: null,
              fundUserWallet: false,
            });
          }}
          onPopupOpened={(e) => {
            e.app.methods.showFullText();
          }}
        >
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            <Block className="pattern-banner bg-color-jasmine">
              <Card style={{ width: "100%", margin: 0 }}>
                <CardHeader>
                  <h3 style={{ margin: 0 }}>{this.state.popupData.title}</h3>
                </CardHeader>
              </Card>
            </Block>

            {/* Content for viewing wallet details */}
            {this.state.popupData.which == "view-wallet" ? (
              <Block>
                <Card style={{ margin: "auto" }}>
                  <CardHeader>
                    {this.state.popupData.data.name
                      ? this.state.popupData.data.name
                      : "Wallet Detail"}
                    <Button
                      outline
                      iconF7="doc_on_clipboard"
                      onClick={(e) => this.$f7.methods.copyText(e, "Wallet Id")}
                    >
                      &nbsp;&nbsp;&nbsp;Wallet Id:
                      <span className="copytext">
                        {this.state.popupData.data.id}
                      </span>
                    </Button>
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        after="Wallet Type"
                        title={
                          +this.state.popupData.data.bonuses >= 0
                            ? "User"
                            : "Partner"
                        }
                      >
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      <ListItem
                        after="Withdrawal Access"
                        title={
                          this.state.popupData.data.ban
                            ? "Access Revoked"
                            : "Access Granted"
                        }
                      >
                        <Icon f7="creditcard" slot="media" />
                      </ListItem>
                      <ListItem
                        after="Wallet Balance"
                        title={new Intl.NumberFormat("en-GB", {
                          style: "currency",
                          currency: "NGN",
                        }).format(
                          +this.state.popupData.data.bonuses >= 0
                            ? this.state.popupData.data.cash
                            : this.state.popupData.data.walletBalance,
                        )}
                      >
                        <Icon f7="number_square" slot="media" />
                      </ListItem>
                      {+this.state.popupData.data.bonuses >= 0 ? (
                        <ListItem
                          after="Bonus Balance"
                          title={new Intl.NumberFormat("en-GB", {
                            style: "currency",
                            currency: "NGN",
                          }).format(this.state.popupData.data.bonuses)}
                        >
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                      ) : null}
                    </List>
                  </CardContent>
                  <CardFooter>
                    {this.state.popupData.data.ban ? (
                      <Button
                        round
                        fill
                        style={{ width: "44%" }}
                        className="button-fill-green"
                        onClick={() =>
                          this.walletAction(
                            this.state.popupData.data.id,
                            "Grant",
                          )
                        }
                      >
                        Grant Access
                      </Button>
                    ) : (
                      <Button
                        round
                        fill
                        style={{ width: "44%" }}
                        className="button-fill-red"
                        onClick={() =>
                          this.walletAction(
                            this.state.popupData.data.id,
                            "Revoke",
                          )
                        }
                      >
                        Revoke Access
                      </Button>
                    )}

                    {+this.state.popupData.data.bonuses >= 0 && (
                      <Row noGap style={{ width: "44%" }}>
                        <Col width="40">
                          <List>
                            <ListInput
                              autofocus
                              type="number"
                              value={this.state.fundWalletAmount}
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  fundWalletAmount: e.target.value,
                                })
                              }
                              name="fund"
                              placeholder="100"
                              required
                              pattern="[0-9]"
                              validate
                              min="1"
                              className="custom-count-input"
                            ></ListInput>
                          </List>
                        </Col>
                        <Col width="60">
                          <Button
                            fill
                            className="button-fill-green"
                            onClick={() =>
                              this.fundUserWallet(this.state.popupData.data.id)
                            }
                            style={{
                              width: "100%",
                              marginTop: "0px",
                              borderTopLeftRadius: "0px",
                              borderBottomLeftRadius: "0px",
                              borderTopRightRadius: "20px",
                              borderBottomRightRadius: "20px",
                            }}
                          >
                            Fund
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </CardFooter>
                </Card>
              </Block>
            ) : null}

            {/* Content for funding all wallet */}
            {this.state.popupData.which == "fund-wallet" ? (
              <Block>
                {/* [Card-1] Fund all wallets */}
                <Card
                  className="data-table data-table-init"
                  style={{
                    width: "100%",
                    maxHeight: "600px",
                    marginLeft: "0px",
                  }}
                >
                  <AccordionItem opened>
                    <CardHeader>
                      <div className="data-table-title">Fund All Wallets</div>
                      <AccordionToggle>
                        <Button
                          outline
                          iconF7="arrowtriangle_down_fill"
                        ></Button>
                      </AccordionToggle>
                    </CardHeader>

                    <AccordionContent>
                      <CardContent
                        padding={false}
                        style={{
                          width: "100%",
                          maxHeight: "500px",
                          overflow: "scroll",
                        }}
                      >
                        {/* Retrieve data from wallets database */}
                        <table className="sticky">
                          <thead>
                            <tr>
                              <th>
                                <span className="table-head-label">SNo.</span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Wallet ID
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Account Name
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Account Type
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Total Transactions
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Wallet Balance
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Withdrawal Access
                                </span>
                              </th>
                              <th>
                                <span className="table-head-label">
                                  Wallet Bonuses
                                </span>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {this.state.wallets
                              .filter((w) => +w.bonuses >= 0)
                              .map(
                                (
                                  {
                                    id,
                                    bankDetails,
                                    ban,
                                    walletBalance,
                                    cash,
                                    bonuses,
                                    name,
                                  },
                                  i,
                                ) => (
                                  <tr key={id}>
                                    <td>{i + 1}</td>
                                    <td>{id}</td>
                                    <td>
                                      <div>{name ? name : "-"}</div>
                                    </td>
                                    <td>
                                      {+bonuses >= 0 ? "User" : "Partner"}
                                    </td>
                                    <td>
                                      {
                                        this.state.transactions.filter(
                                          ({ walletId }) => walletId === id,
                                        ).length
                                      }
                                    </td>
                                    <td>
                                      <div>
                                        {new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(cash)}
                                      </div>
                                    </td>
                                    <td>
                                      {ban ? (
                                        <div>Access Denied</div>
                                      ) : (
                                        <div>Access</div>
                                      )}
                                    </td>
                                    <td>
                                      <div>
                                        {new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(bonuses)}
                                      </div>
                                    </td>
                                  </tr>
                                ),
                              )}
                          </tbody>
                        </table>
                      </CardContent>
                      <CardFooter>
                        <Row style={{ width: "100%" }}>
                          <Col width="55">
                            <Row noGap>
                              <Col width="30">
                                <List>
                                  <ListInput
                                    autofocus
                                    type="number"
                                    value={this.state.fundAllwalletsAmount}
                                    onChange={(e) =>
                                      this.setState({
                                        ...this.state,
                                        fundAllwalletsAmount: e.target.value,
                                      })
                                    }
                                    name="fund"
                                    placeholder="100"
                                    required
                                    pattern="[0-9]"
                                    validate
                                    min="1"
                                    className="custom-count-input"
                                  ></ListInput>
                                </List>
                              </Col>
                              <Col width="70">
                                <pre
                                  style={{
                                    marginTop: "0px",
                                    backgroundColor: "#f3f3f3",
                                    textAlign: "center",
                                    padding: "8.5px 0",
                                    border: "1px solid hsla(0, 0%, 90%, 1)",
                                    borderTopRightRadius: "20px",
                                    borderBottomRightRadius: "20px",
                                  }}
                                >
                                  {new Intl.NumberFormat("en-GB", {
                                    style: "currency",
                                    currency: "NGN",
                                  }).format(
                                    this.state.wallets.filter(
                                      (w) => +w.bonuses >= 0,
                                    ).length * +this.state.fundAllwalletsAmount,
                                  )}
                                </pre>
                              </Col>
                            </Row>
                          </Col>

                          <Col width="45">
                            <Button
                              fill
                              round
                              onClick={this.fundAllUsersWallet.bind(this)}
                              className="button-fill-green"
                              style={{
                                width: "100%",
                              }}
                            >
                              Fund
                            </Button>
                          </Col>
                        </Row>
                      </CardFooter>
                    </AccordionContent>
                  </AccordionItem>
                </Card>

                {/* [Card-2]  Admin Wallet Funding*/}
                <Card style={{ margin: "10pt auto" }} inner accordionList>
                  <AccordionItem>
                    <CardHeader>
                      Fund Easychaw wallet
                      <AccordionToggle>
                        <Button
                          outline
                          iconF7="arrowtriangle_down_fill"
                        ></Button>
                      </AccordionToggle>
                    </CardHeader>

                    <AccordionContent>
                      <CardContent>
                        <List noHairlinesMd>
                          <ListItem title="Fee">
                            <small slot="after">
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(
                                paystackTransactionCharge(
                                  this.state.adminFundWalletAmount,
                                ),
                              )}
                            </small>
                            <Icon f7="creditcard" slot="media" />
                          </ListItem>
                          <ListInput
                            label="Amount to deposit"
                            input={false}
                            info="Default validation"
                            style={{ paddingLeft: 0 }}
                          >
                            <Icon f7="creditcard_fill" slot="media" />

                            <Cleave
                              slot="input"
                              options={{
                                numeral: true,
                                numeralThousandsGroupStyle: "thousand",
                              }}
                              value={this.state.adminFundWalletAmount}
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  adminFundWalletAmount: e.target.rawValue,
                                })
                              }
                              placeholder="Minimum wallet funding is NGN 100"
                              min="100"
                              required
                            />
                          </ListInput>
                        </List>
                      </CardContent>
                      <CardFooter className="easyPrintText">
                        <pre className="round">
                          <small>For bonus use</small>
                        </pre>

                        {+this.state.adminFundWalletAmount >= 100 && (
                          <PaystackButton
                            text="Fund with Paystack"
                            className="button button-fill-blue special-paystack-button"
                            onSuccess={this.callback.bind(this)}
                            onClose={this.close}
                            reference={this.reference()}
                            email={
                              !this.props.profile.isEmpty &&
                              this.props.profile.email
                            }
                            metadata={{
                              name:
                                !this.props.profile.isEmpty &&
                                this.props.profile.fullName,
                              phone:
                                !this.props.profile.isEmpty &&
                                this.props.profile.phoneNumber,

                              transaction: {
                                doc: this.reference(),
                                body: {
                                  walletId: this.props.profile.walletId,
                                  name: this.props.profile.fullName,
                                  status: "Success",
                                  type: "Received",
                                  by: "Easychaw",
                                  // This is service charge and no longer paystack charge. i didn't change it cos it will break alot of things
                                  note: "Easychaw Deposit",
                                  paystackCharge: paystackTransactionCharge(
                                    this.state.adminFundWalletAmount,
                                  ),
                                  amount: +this.state.adminFundWalletAmount,
                                },
                              },
                            }}
                            amount={+this.state.adminFundWalletAmount * 100}
                            publicKey={PAYSTACK_PUBLIC_KEY}
                          />
                        )}
                      </CardFooter>
                    </AccordionContent>
                  </AccordionItem>
                </Card>

                {/* [Card-3]  Admin Wallet Funding History*/}
                <Card
                  className="data-table data-table-init"
                  style={{
                    width: "100%",
                    maxHeight: "600px",
                    marginLeft: "0px",
                  }}
                  inner
                  accordionList
                >
                  <AccordionItem>
                    <CardHeader>
                      <div className="data-table-title">
                        Bonus Funding History
                      </div>
                      <AccordionToggle>
                        <Button
                          outline
                          iconF7="arrowtriangle_down_fill"
                        ></Button>
                      </AccordionToggle>
                    </CardHeader>

                    <AccordionContent>
                      <CardContent
                        padding={false}
                        style={{
                          width: "100%",
                          maxHeight: "500px",
                          overflow: "scroll",
                        }}
                      >
                        <Card>
                          <CardHeader>
                            Total Amount Funded
                            <div style={{ color: "red" }}>
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(
                                this.props.ordered.transactions
                                  .filter((t) => t.record === true)
                                  .filter(
                                    (t) =>
                                      +moment(t.timestamp) >=
                                        +moment(this.state.timeFrom) &&
                                      +moment(t.timestamp) <=
                                        +moment(this.state.timeTo),
                                  )
                                  .map((t) => +t.amount)
                                  .reduce((a, b) => +a + +b, 0),
                              )}
                            </div>
                          </CardHeader>
                          <CardContent>
                            <List>
                              <ListInput
                                key="timeFrom"
                                label={"From"}
                                type="datepicker"
                                placeholder="Select date and time"
                                readonly
                                calendarParams={{
                                  dateFormat: {
                                    month: "numeric",
                                    day: "numeric",
                                    year: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                  },
                                  timePicker: true,
                                }}
                                onCalendarChange={(value) => {
                                  this.setState({
                                    ...this.state,
                                    timeFrom: value[0],
                                  });
                                }}
                              />
                              <ListInput
                                key="timeTo"
                                label={"To"}
                                type="datepicker"
                                placeholder="Select date and time"
                                readonly
                                calendarParams={{
                                  dateFormat: {
                                    month: "numeric",
                                    day: "numeric",
                                    year: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                  },
                                  timePicker: true,
                                }}
                                onCalendarChange={(value) => {
                                  this.setState({
                                    ...this.state,
                                    timeTo: value[0],
                                  });
                                }}
                              />
                            </List>
                          </CardContent>
                        </Card>

                        {/* Retrieve wallet funding history */}
                        {this.props.ordered.transactions.filter(
                          (t) => t.record === true,
                        ).length === 0 ? (
                          <Block className="block-info">
                            <Row>
                              <Col>
                                <p>No bonus history available at the moment</p>
                              </Col>
                            </Row>
                          </Block>
                        ) : (
                          <table className="sticky">
                            <thead>
                              <tr>
                                <th>
                                  <span className="table-head-label">SNo.</span>
                                </th>
                                <th>
                                  <span className="table-head-label">User</span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Funded By
                                  </span>
                                </th>
                                <th>
                                  <span className="table-head-label">Role</span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Bonus
                                  </span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Timestamp
                                  </span>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {this.props.ordered.transactions
                                .filter((t) => t.record === true)
                                .filter(
                                  (t) =>
                                    +moment(t.timestamp) >=
                                      +moment(this.state.timeFrom) &&
                                    +moment(t.timestamp) <=
                                      +moment(this.state.timeTo),
                                )
                                .map(
                                  (
                                    {
                                      id,
                                      name,
                                      fundedBy,
                                      role,
                                      amount,
                                      timestamp,
                                    },
                                    i,
                                  ) => (
                                    <tr key={id}>
                                      <td>{i + 1}</td>
                                      <td>
                                        <div>{name}</div>
                                      </td>
                                      <td>
                                        <div>{fundedBy}</div>
                                      </td>
                                      <td>
                                        <div>{role}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {new Intl.NumberFormat("en-GB", {
                                            style: "currency",
                                            currency: "NGN",
                                          }).format(amount)}
                                        </div>
                                      </td>

                                      <td>
                                        <div>
                                          {moment(timestamp).format(
                                            "DD MMM YYYY | hh:mm a",
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  ),
                                )}
                            </tbody>
                          </table>
                        )}
                      </CardContent>
                    </AccordionContent>
                  </AccordionItem>
                </Card>
              </Block>
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  //   Lifecycle
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.filterBy.dbName.trim() === "") {
      return {
        wallets: (nextProps.ordered && nextProps.ordered.wallets) || [],
        transactions:
          (nextProps.ordered && nextProps.ordered.transactions) || [],
      };
    } else {
      let modifiedState = {
        wallets: (nextProps.ordered && nextProps.ordered.wallets) || [],
        transactions:
          (nextProps.ordered && nextProps.ordered.transactions) || [],
      };

      switch (prevState.filterBy.dbName) {
        case "wallets":
          let filter;
          switch (prevState.filterBy.type) {
            case "text":
              filter = new FilterByText(modifiedState.wallets);
              return (modifiedState = {
                ...modifiedState,
                wallets: filter.filter(prevState),
              });
            case "select":
              filter = new FilterBySelect(modifiedState.wallets);
              return (modifiedState = {
                ...modifiedState,
                wallets: filter.filter(prevState),
              });
            default:
              filter = new FilterByNumber(modifiedState.wallets);
              return (modifiedState = {
                ...modifiedState,
                wallets: filter.filter(prevState),
              });
          }
        case "transactions":
          switch (prevState.filterBy.type) {
            case "text":
              filter = new FilterByText(modifiedState.transactions);
              return (modifiedState = {
                ...modifiedState,
                transactions: filter.filter(prevState),
              });
            case "number":
              filter = new FilterByNumber(modifiedState.transactions);
              return (modifiedState = {
                ...modifiedState,
                transactions: filter.filter(prevState),
              });

            default:
              filter = new FilterBySelect(modifiedState.transactions);
              return (modifiedState = {
                ...modifiedState,
                transactions: filter.filter(prevState),
              });
          }

        default:
        // inbox
      }
    }

    return null;
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      unSubscribeCompleteOrders: this.props.firestore
        .collection("orders")
        .where("orderStatus", "in", [
          "Order Pending",
          "Order Pending Delivery",
          "Order Pending Confirmation",
        ])
        .onSnapshot((snapshots) => {
          if (!snapshots.empty) {
            let data = [];
            snapshots.forEach((snapshot) => {
              data.push(snapshot.data());
            });

            this.setState({
              ...this.state,
              unCompleteOrders: data,
            });
          } else {
            this.setState({
              ...this.state,
              unCompleteOrders: [],
            });
          }
        }),
    });
  }

  componentWillUnmount() {
    this.state.unSubscribeCompleteOrders();
  }

  close() {}

  reference() {
    return this.state.reference;
  }

  callback(response) {
    this.$f7.preloader.show();
    if (response.status === "success") {
      this.setState({
        ...this.state,
        popupOpened: false,
        popupDataChanged: false,
        popupData: { title: "", which: "", data: {} },
        vendor: null,
        adminFundWalletAmount: "",
        reference: generateId(15),
      });

      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Transaction Approved, wallet will be credited as soon as your card is charged",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    } else {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: response.message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  fundAllUsersWallet() {
    this.$f7.preloader.show();
    const amount = this.state.fundAllwalletsAmount;

    // validate
    if (amount <= 0) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Invalid input",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (
      this.state.wallets.filter((w) => +w.bonuses >= 0).length * +amount >
      totalWalletBalance(
        this.props.ordered.transactions,
        this.state.unCompleteOrders,
      )
    ) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Insufficient balance.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        // send OTP to Easychaw's email
        sendEasychawOneTimePassword(
          {
            token: idToken,
            uid: this.props.auth.uid,
            actions: "Fund",
            details: { amount, howMany: "All" },
          },
          (error, sent) => {
            if (error || !sent) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: error,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            // open a dialog to confirm OTP
            this.$f7.preloader.hide();
            this.$f7.dialog
              .create({
                title: "OTP CODE",
                cssClass: "otp-code-modal",
                text: "Confirm funding by filling in the OTP code sent to Easychaw's email address",
                content: `<input class="dialog-input split-input" type="password" maxlength="4" />`,
                buttons: [
                  // button to resend otp
                  {
                    text: "Resend Code",
                    color: "gray",
                    cssClass: "otp-resend",

                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      sendEasychawOneTimePassword(
                        {
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, sent) => {
                          if (error || !sent) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: "OTP code sent",
                            position: "bottom",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        },
                      );
                    },
                  },
                  // button to cancel
                  {
                    text: "x",
                    color: "white",
                    cssClass: "otp-close",
                    onClick: (dialog, e) => {
                      this.$f7.preloader.hide();
                    },
                  },
                  // button to continue
                  {
                    text: "Continue",
                    bold: true,
                    cssClass: "otp-continue",
                    keyCodes: [13],
                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      // password
                      const password = dialog.$el.find(".dialog-input").val();

                      // Verify otp
                      verifyEasychawOneTimePassword(
                        {
                          password,
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, success) => {
                          if (error || !success) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          // close dialog
                          dialog.close();
                          fundAllWallets(
                            amount,
                            idToken,
                            this.props.auth.uid,
                            (error, message) => {
                              if (error) {
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              }

                              this.setState({
                                ...this.state,
                                popupOpened: false,
                                popupDataChanged: false,
                                popupData: { title: "", which: "", data: {} },
                                vendor: null,
                                fundUserWallet: false,
                                fundAllUsersWallet: 0,
                              });
                              this.$f7.preloader.hide();

                              return toast(this.$f7.toast, {
                                text: `Wallet Funded`,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            },
                          );
                        },
                      );
                    },
                  },
                ],
              })
              .open();
          },
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: error,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  // fund a wallet
  fundUserWallet(walletId) {
    this.$f7.preloader.show();
    const amount = this.state.fundWalletAmount;

    // validate
    if (amount <= 0) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Invalid input",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (
      +amount >
      totalWalletBalance(
        this.props.ordered.transactions,
        this.state.unCompleteOrders,
      )
    ) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Insufficient balance.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        // send OTP to Easychaw's email
        sendEasychawOneTimePassword(
          {
            token: idToken,
            uid: this.props.auth.uid,
            actions: "Fund",
            details: { amount, howMany: "Single" },
          },
          (error, sent) => {
            if (error || !sent) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: error,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            // open a dialog to confirm OTP
            this.$f7.preloader.hide();
            this.$f7.dialog
              .create({
                title: "OTP CODE",
                cssClass: "otp-code-modal",
                text: "Confirm funding by filling in the OTP code sent to Easychaw's email address",
                content: `<input class="dialog-input split-input" type="password" maxlength="4" />`,
                buttons: [
                  // button to resend otp
                  {
                    text: "Resend Code",
                    color: "gray",
                    cssClass: "otp-resend",

                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      sendEasychawOneTimePassword(
                        {
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, sent) => {
                          if (error || !sent) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: "OTP code sent",
                            position: "bottom",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        },
                      );
                    },
                  },
                  // button to cancel
                  {
                    text: "x",
                    color: "white",
                    cssClass: "otp-close",
                    onClick: (dialog, e) => {
                      this.$f7.preloader.hide();
                    },
                  },
                  // button to continue
                  {
                    text: "Continue",
                    bold: true,
                    cssClass: "otp-continue",
                    keyCodes: [13],
                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      // password
                      const password = dialog.$el.find(".dialog-input").val();

                      // Verify otp
                      verifyEasychawOneTimePassword(
                        {
                          password,
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, success) => {
                          if (error || !success) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          // close dialog
                          dialog.close();
                          fundWallet(
                            walletId,
                            amount,
                            idToken,
                            this.props.auth.uid,
                            (error, message) => {
                              if (error) {
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              }

                              this.setState({
                                ...this.state,
                                popupOpened: false,
                                popupDataChanged: false,
                                popupData: { title: "", which: "", data: {} },
                                vendor: null,
                                fundUserWallet: false,
                                fundWalletAmount: 0,
                              });
                              this.$f7.preloader.hide();

                              return toast(this.$f7.toast, {
                                text: `Wallet Funded`,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            },
                          );
                        },
                      );
                    },
                  },
                ],
              })
              .open();
          },
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: error,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  //   Events
  walletAction(walletId, action) {
    this.$f7.preloader.show();
    const ban = action === "Revoke" ? true : false;
    this.props.firestore
      .collection("wallets")
      .doc(walletId)
      .update({ ban })
      .then(() => {
        this.setState({
          ...this.state,
          popupOpened: false,
          popupDataChanged: false,
          popupData: { title: "", which: "", data: {} },
          vendor: null,
          fundUserWallet: false,
        });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: "Action Successful",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: { data, ordered },
}) => ({
  auth,
  profile,
  data,
  ordered,
});

const enhance = compose(
  withFirestore,
  firestoreConnect([
    new Collections("wallets"),
    new Collections("transactions"),
  ]),
  connect(mapStateToProps),
);

export default enhance(AdminWallets);
